"use client";

import { useQuery } from "@tanstack/react-query";
import useUserStore from "@/global-store/user";
import { useUserStoreHydrated } from "@/hook/use-user-store-hydrated";
import { categoryService } from "@/services/category";
import Navbar from "./Navbar";

export const NavbarWithCategories = () => {
  const hasHydrated = useUserStoreHydrated();
  const user = useUserStore((state) => state.user);
  const isCompanyUser = hasHydrated && !!user;

  const { data } = useQuery({
    queryKey: ["navbar-categories", isCompanyUser],
    queryFn: () =>
      categoryService.getCategoriesForUser(isCompanyUser, {
        page: 1,
        limit: 10,
      }),
    enabled: hasHydrated,
    staleTime: 60_000,
  });

  return <Navbar categories={data?.data?.data ?? []} />;
};
